module.exports = __webpack_public_path__ + "img/steeringAngleHor.2b96d977.svg";